/* ============================================================
   assets/bh-cod-form.js
   No dependencies. No jQuery. ~5 KB.

   Layer 1 (no JS)  : native form POST → /cart/add → /cart
   Layer 2 (this)   : inline validation, live total, lead capture
   Layer 3 (worker) : POST to the Draft Order worker, no checkout

   Layer 3 no longer degrades to Shopify's checkout. It used to, and the
   rescue was worse than the failure: this shop is paid at the door, so a
   customer who filled in a cash-on-delivery form and pressed ORDER landed
   on a card form, in English, with their name and address carried over as
   line-item properties — and no order created. A failed send now says so
   on this page and leaves the phone number in reach.

   This is the only JavaScript file the theme ships.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-bh-cod]');
  if (!root) return;

  var form      = root.querySelector('[data-bh-form]');
  var paneForm  = root.querySelector('[data-bh-pane="form"]');
  var paneDone  = root.querySelector('[data-bh-pane="done"]');
  var submitBtn = root.querySelector('[data-bh-submit]');
  var ctaLabel  = root.querySelector('[data-bh-cta]');
  var totalEl   = root.querySelector('[data-bh-total]');
  var variantEl = root.querySelector('[data-bh-variant]');
  var savedEl   = root.querySelector('[data-bh-saved]');
  var savedNote = root.querySelector('[data-bh-saved-note]');
  if (!form) return;

  var SOLD_OUT = !!(submitBtn && submitBtn.disabled);
  var MODE     = root.dataset.mode || 'checkout';
  var ENDPOINT = root.dataset.endpoint || '';
  var LEAD     = root.dataset.leadEndpoint || '';
  var PRODUCT  = root.dataset.productTitle || document.title;

  var STORE_KEY = 'bh_cod_draft';
  var sending = false;

  /* ---------- money -------------------------------------- */
  /* The section renders one sample amount through Shopify's own money
     filter; whatever sits before the first digit and after the last one is
     the shop's prefix and suffix. Derived, not parsed — the money_format
     string itself is full of edge cases, and getting it wrong writes the
     raw placeholder onto the price. */
  var MONEY_PRE = '';
  var MONEY_SUF = ' KM';
  (function () {
    var sample = root.dataset.moneySample || '';

    /* Strip markup first. A shop can set its currency format to the HTML
       variant — Shopify offers "HTML with currency" right next to the plain
       one — and then the sample arrives as
       `<span class=money>KM 49</span>`. The prefix would become
       `<span class=money>KM ` and the suffix `</span>`, and since every
       consumer of money() assigns through textContent, the customer reads
       the tags: "NARUCI POUZECEM — <span class=money>KM 88</span>" on the
       one button that matters.

       Found live on Moments. Nordik never saw it because that shop's
       format has no markup — which is exactly why it is stripped here
       rather than fixed in the shop's settings: this must survive a
       merchant flipping that dropdown. Stripping a sample that has no
       tags is a no-op. */
    sample = sample
      .replace(/<[^>]*>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&');

    var first = sample.search(/\d/);
    if (first < 0) return;
    var last = sample.length - 1;
    while (last >= 0 && !/\d/.test(sample.charAt(last))) last--;
    MONEY_PRE = sample.slice(0, first);
    MONEY_SUF = sample.slice(last + 1);
  })();

  /* Shopify money is in minor units (fening). 4900 → "KM 49" */
  function money(cents) {
    var n = cents / 100;
    var s = (n % 1 === 0) ? String(n) : n.toFixed(2).replace('.', ',');
    return MONEY_PRE + s + MONEY_SUF;
  }

  /* ---------- validation --------------------------------- */
  var RULES = {
    name:    function (v) { return v.trim().length >= 3; },
    /* Eight digits after the country code, however the number was written.
       The old rule counted raw digits between 8 and 12, which accepted
       06487019 — one short of a real mobile — and let it through to
       Shopify, which refused the whole order and told the customer to
       check her internet. Same normalisation as the worker: shed 00, 387
       and a leading zero, then count. */
    phone:   function (v) {
      var d = v.replace(/\D/g, '').replace(/^00/, '').replace(/^387/, '').replace(/^0/, '');
      return d.length === 8;
    },
    address: function (v) { return v.trim().length >= 4; },
    city:    function (v) { return v.trim().length >= 2; },
    /* The two optional ones: empty is valid, so neither can ever block an
       order. Only a non-empty malformed value errors. The email check is
       deliberately loose — the strict RFC pattern rejects real addresses,
       and the cost of a typo is a bounced mail, not a lost delivery. A
       blank zip is filled in from the city by the worker. */
    zip:     function (v) { var s = v.trim(); return s === '' || /^[0-9]{5}$/.test(s); },
    email:   function (v) { var s = v.trim(); return s === '' || /^[^\s@]+@[^\s@.]+\.[^\s@]{2,}$/.test(s); }
  };

  function fieldOf(key) { return root.querySelector('[data-bh-field="' + key + '"]'); }
  function inputOf(key) { var f = fieldOf(key); return f && f.querySelector('.bh-input'); }

  /* The field's own label, so the summary names fields the way the page
     does — minus the "(opcionalno)" suffix, which would read as noise in
     a list of problems. Read from the DOM so it stays translated. */
  function labelOf(key) {
    var f = fieldOf(key);
    var l = f && f.querySelector('label');
    if (!l) return key;
    var opt = l.querySelector('.bh-field__opt');
    var text = l.textContent;
    if (opt) text = text.replace(opt.textContent, '');
    return text.replace(/\s+/g, ' ').trim();
  }

  function check(key, showError) {
    var input = inputOf(key);
    if (!input) return true;
    var ok = RULES[key](input.value);
    if (showError) {
      fieldOf(key).setAttribute('data-invalid', ok ? 'false' : 'true');
      /* aria-invalid is what a screen reader announces on the field
         itself; aria-describedby (set in the section) points at the
         message under it. */
      input.setAttribute('aria-invalid', ok ? 'false' : 'true');
    }
    return ok;
  }

  /* Returns every bad field, in the order they appear on the page, so the
     summary can name them and focus can go to the first one. */
  function validateAll(showErrors) {
    return Object.keys(RULES).filter(function (key) {
      return !check(key, showErrors);
    });
  }

  var formErr = root.querySelector('[data-bh-formerr]');

  function showFormError(bad) {
    if (!formErr) return;
    if (!bad.length) {
      formErr.hidden = true;
      formErr.textContent = '';
      return;
    }
    var names = bad.map(labelOf).join(', ');
    formErr.textContent = (root.dataset.errFormLabel || 'Narudžba nije poslana. Provjerite:') + ' ' + names;
    formErr.hidden = false;
  }

  /* Errors clear as soon as the field becomes valid — never nag */
  Object.keys(RULES).forEach(function (key) {
    var input = inputOf(key);
    if (!input) return;
    input.addEventListener('input', function () {
      if (fieldOf(key).getAttribute('data-invalid') === 'true') check(key, true);
      /* Once the summary is up, keep it honest: the list shrinks as fields
         get fixed and disappears when nothing is left. Only re-validates
         everything after a failed submit, so it never nags first-time. */
      if (formErr && !formErr.hidden) showFormError(validateAll(true));
      persist();
    });
    input.addEventListener('blur', function () {
      if (input.value.trim() !== '') check(key, true);
      if (key === 'phone') onPhoneBlur(input.value);
    });
  });

  /* ---------- draft persistence (survives a reload) ------- */
  function persist() {
    try {
      var data = {};
      Object.keys(RULES).forEach(function (k) { var i = inputOf(k); if (i) data[k] = i.value; });
      localStorage.setItem(STORE_KEY, JSON.stringify(data));
    } catch (e) { /* private mode — ignore */ }
  }

  function restore() {
    try {
      var raw = localStorage.getItem(STORE_KEY);
      if (!raw) return;
      var data = JSON.parse(raw);
      Object.keys(RULES).forEach(function (k) {
        var i = inputOf(k);
        if (i && !i.value && data[k]) i.value = data[k];
      });
    } catch (e) { /* ignore */ }
  }
  restore();

  /* ---------- lead capture on phone blur ------------------ */
  var leadSent = false;
  function onPhoneBlur(value) {
    var ok = RULES.phone(value);
    if (savedEl) savedEl.setAttribute('data-on', ok ? 'true' : 'false');
    /* The tick is aria-hidden, so the sentence is what a screen reader gets.
       Writing it into a role=status region is what makes it announce. */
    if (savedNote) savedNote.textContent = ok ? (savedNote.dataset.text || '') : '';
    if (!ok || leadSent || !LEAD) return;
    leadSent = true;
    var body = JSON.stringify({
      phone: value,
      product: PRODUCT,
      url: location.href,
      at: new Date().toISOString()
    });
    /* sendBeacon survives the customer closing the tab mid-form.
       text/plain, not application/json: application/json is not a
       CORS-safelisted content type, so it forces a preflight, and a
       preflight cannot complete while the page is unloading — which
       is exactly the moment this call has to survive. The body is
       still JSON; the worker parses either. */
    if (navigator.sendBeacon) {
      navigator.sendBeacon(LEAD, new Blob([body], { type: 'text/plain;charset=UTF-8' }));
    } else {
      fetch(LEAD, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=UTF-8' }, body: body, keepalive: true })
        .catch(function () { leadSent = false; });
    }
  }

  /* ---------- pack picker --------------------------------- */
  var currentPrice = parseInt(root.dataset.price, 10) || 0;
  var currentPack  = '';
  var packs = root.querySelectorAll('[data-bh-pack]');

  /* ---------- koliko komada ------------------------------- */
  /* currentPrice je cijena JEDNOG komada izabrane varijante. Sve sto se
     placa mnozi se ovim brojem; hero cijena se ne mnozi, jer je to broj
     iz oglasa i mora se poklapati sa onim sto je kupca dovelo.

     Brojac postoji samo na proizvodima bez opcije pakovanja — vidi
     bh-cod-order-form.liquid. Kad ga nema, qty() je jedan i sve ostaje
     tacno kako je bilo. */
  var qtyEl = root.querySelector('[data-bh-qty-input]');

  function qty() {
    if (!qtyEl) return 1;
    var n = parseInt(qtyEl.value, 10);
    if (isNaN(n) || n < 1) n = 1;
    if (n > 10) n = 10;
    return n;
  }

  /* ---------- koji komad je koja boja --------------------- */
  /* Brojac mnozi jednu varijantu. Na proizvodu sa tri boje to znaci tri
     iste, a na mindjusama za vise rupica kupac trazi upravo suprotno.
     Zato svaki komad poslije prvog dobija svoj red i svoj izbor.

     Prvi komad NIJE red — to je ono sto je izabrano u pikeru gore, i na
     tome visi ostatak forme (cijena u zaglavlju, slika, precrtana
     cijena, rasprodato). Ovdje se dodaje samo ono cega tamo nema. */
  var mixBox  = root.querySelector('[data-mc-mix]');
  var mixRows = root.querySelector('[data-mc-mix-rows]');
  var VARIANTS = [];
  try {
    var vjson = root.querySelector('[data-mc-variants]');
    if (vjson) VARIANTS = JSON.parse(vjson.textContent) || [];
  } catch (e) { VARIANTS = []; }

  /* Cijena uz ime boje samo kad se boje razlikuju po cijeni. Kad su sve
     iste, ponovljena ista cifra u svakom redu ne kaze nista i samo
     zatrpava izbor. */
  var MIXED_PRICES = VARIANTS.some(function (x) {
    return VARIANTS.length && x.price !== VARIANTS[0].price;
  });

  function mixSelects() {
    return mixRows ? mixRows.querySelectorAll('[data-mc-mix-pick]') : [];
  }

  /* Izabrane varijante za komade od drugog nadalje. Nedostupne se ne nude,
     pa ono sto se ovdje procita uvijek postoji na stanju. */
  function extras() {
    var out = [];
    Array.prototype.forEach.call(mixSelects(), function (sel) {
      if (sel.value) out.push(sel.value);
    });
    return out;
  }

  function variantById(id) {
    for (var i = 0; i < VARIANTS.length; i++) {
      if (String(VARIANTS[i].id) === String(id)) return VARIANTS[i];
    }
    return null;
  }

  function renderMix() {
    /* Na ramovima su svi ramovi jedne narudžbe ista boja i veličina —
       broj bira mc-frame-builder, pa redovi „koji komad je koja boja"
       ne smiju postojati (ostali bi na staroj boji kad kupac promijeni). */
    if (frame) {
      if (mixRows) mixRows.innerHTML = '';
      if (mixBox) mixBox.hidden = true;
      return;
    }
    if (!mixBox || !mixRows || VARIANTS.length < 2) return;

    var need = qty() - 1;
    if (need < 1) {
      mixRows.innerHTML = '';
      mixBox.hidden = true;
      return;
    }

    /* Vec izabrano se pamti preko prerisavanja. Ko podigne brojac sa dva
       na tri, ne smije izgubiti boju koju je izabrao za drugi komad. */
    var keep = extras();
    var mainId = variantEl ? variantEl.value : '';

    var html = '';
    /* Prvi komad, ispisan a ne ponudjen: on je izbor iz pikera gore i
       mijenja se tamo. Stoji u listi da bi se vidjelo da su sva tri
       komada nabrojana, a ne samo dva. */
    var mainV = variantById(mainId);
    html += '<div class="mc-mix__row mc-mix__row--main">'
          +   '<span class="mc-mix__n">1.</span>'
          +   '<span class="mc-mix__fixed">' + (mainV ? escapeHtml(mainV.title) : '') + '</span>'
          + '</div>';

    for (var i = 0; i < need; i++) {
      var chosen = keep[i] || mainId;
      html += '<div class="mc-mix__row">'
            +   '<span class="mc-mix__n">' + (i + 2) + '.</span>'
            +   '<select class="mc-mix__pick" data-mc-mix-pick '
            +     'aria-label="' + escapeHtml(MIX_LABEL.replace('{n}', i + 2)) + '">';
      for (var j = 0; j < VARIANTS.length; j++) {
        var v = VARIANTS[j];
        if (!v.available) continue;
        var label = v.title + (MIXED_PRICES ? ' — ' + money(v.price) : '');
        html += '<option value="' + v.id + '"'
              + (String(v.id) === String(chosen) ? ' selected' : '') + '>'
              + escapeHtml(label) + '</option>';
      }
      html += '</select></div>';
    }

    mixRows.innerHTML = html;
    mixBox.hidden = false;
  }

  function escapeHtml(t) {
    return String(t).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  var MIX_LABEL = (mixBox && mixBox.getAttribute('data-row-label')) || 'Komad {n}';

  /* Roba = komad iz pikera plus svaki dodatni po SVOJOJ cijeni. Mnozenje
     jedne cijene brojem komada lagalo bi cim se izaberu dvije boje koje
     ne kostaju isto. */
  /* Komadi poslije prvog koji nemaju svoj red za izbor boje. Redovi
     postoje samo na proizvodu s vise varijanti; na proizvodu s jednom
     varijantom brojac je jedini izvor, pa su svi dodatni komadi isti kao
     prvi. Bez ovoga je brojac na takvom proizvodu pokazivao „2", a cijena
     i narudzba ostajali na jednom komadu. */
  function plainExtra() {
    return Math.max(0, qty() - 1 - extras().length);
  }

  function goods() {
    /* Magnetni ramovi: cijenu seta računa mc-frame.js iz istog metapolja
       iz kojeg je worker računa za narudžbu, pa dugme i kurir kažu isto. */
    if (frame) return frame.goodsCents;
    var sum = currentPrice;
    extras().forEach(function (id) {
      var v = variantById(id);
      sum += v ? v.price : currentPrice;
    });
    return sum + plainExtra() * currentPrice;
  }

  /* Sve linije narudzbe: isti komad izabran dvaput je jedna linija sa
     kolicinom dva, jer je to jedna stavka na racunu koji kupac cita kod
     vrata. Redoslijed je redoslijed izbora, pa prva ostaje ona iz pikera. */
  function orderCounts() {
    var order = [];
    var count = {};
    var push = function (id) {
      if (!id) return;
      if (!count[id]) { count[id] = 0; order.push(id); }
      count[id]++;
    };
    push(variantEl ? variantEl.value : '');
    extras().forEach(push);
    for (var i = 0; i < plainExtra(); i++) push(variantEl ? variantEl.value : '');
    return order.map(function (id) { return { id: id, n: count[id] }; });
  }

  function setQty(n) {
    if (!qtyEl) return;
    if (n < 1) n = 1;
    if (n > 10) n = 10;
    qtyEl.value = n;
    renderMix();
    /* Skriveno polje forme drzi isti broj. Taj POST je zaustavljen dok
       skripta radi, ali ako ikad prodje, ne smije naruciti jedan komad
       kad na ekranu pise tri. */
    var hidden = root.querySelector('[data-bh-form] input[name="quantity"]');
    if (hidden) hidden.value = n;
    paintPrice();
  }

  function selectPack(btn) {
    Array.prototype.forEach.call(packs, function (p) {
      p.setAttribute('aria-checked', p === btn ? 'true' : 'false');
    });
    if (variantEl) variantEl.value = btn.dataset.variantId;
    currentPrice = parseInt(btn.dataset.price, 10);
    currentPack  = btn.dataset.packName || '';
    renderMix();
    paintPrice();
    showShot(btn.dataset.media);
  }

  /* The gallery lives in its own section and switches on hidden radios, so
     it is reached from `document`, not `root`. Liquid put the position of
     each variant's image on the button; a pack whose image is not in the
     rendered eight has no attribute and the photo is left alone — better a
     stale-but-correct picture than one that jumps to image 1 on every tap.

     Clicking the label would work too, but `checked` plus an input event
     is what the radio itself would do, and it does not depend on a label
     existing for that index. */
  function showShot(n) {
    if (!n) return;
    var radio = document.getElementById('bh-gal-' + n);
    if (!radio || radio.checked) return;
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /* Delivery is charged once per order and is the same for every pack. The
     worker bills the identical figure, so the button and the Shopify order
     agree to the fening. */
  var SHIPPING = parseInt(root.dataset.shipping, 10) || 0;

  /* ---------- the dedication card ------------------------- */
  /* sections/mc-dedication.liquid owns the UI and emits mc:dedication on
     every change. This form owns two consequences of it: the amount the
     courier will ask for, and what reaches the Shopify order.

     Kept as plain state updated by the event rather than read out of the
     DOM at submit time, so the figure on the button and the figure in the
     payload are computed from the same source and cannot drift. */
  var ded = { card: false, text: '', sign: '', feeCents: 0, cardVariantId: '' };

  /* Seeded from the DOM, not from the first event.

     mc-dedication.js emits once as it initialises, and whether this file
     is listening by then depends on which section Liquid rendered first —
     an ordering that changes the moment somebody drags a section in the
     theme editor. The card is checked BY DEFAULT, so missing that first
     event means the button quotes a total 15 KM short of what the courier
     will ask for, until the customer happens to touch the block. Reading
     the state directly makes script order irrelevant. */
  /* Konfigurator poklona (sections/mc-gift-builder.liquid) nosi i polja
     koja štampa kartice čita odvojeno: naslov, rođendanski red, šifru
     poruke. Drži ih u data-extra kao JSON. Stara sekcija posvete ga nema,
     pa za nju ovo vraća null i ništa se ne mijenja. */
  function readExtra(d) {
    try { return d.dataset.extra ? JSON.parse(d.dataset.extra) : null; }
    catch (e) { return null; }
  }

  (function seedDedication() {
    var d = document.querySelector('[data-mc-dedication]');
    if (!d) return;
    var card = d.querySelector('[data-mc-prop-card]');
    var text = d.querySelector('[data-mc-prop-text]');
    var sign = d.querySelector('[data-mc-prop-sign]');
    ded = {
      card: !!card && card.value === 'Da',
      text: text ? text.value : '',
      sign: sign ? sign.value : '',
      feeCents: parseInt(d.dataset.fee, 10) || 0,
      cardVariantId: d.dataset.cardVariant || '',
      extra: readExtra(d)
    };
  })();

  document.addEventListener('mc:dedication', function (ev) {
    if (!ev.detail) return;
    ded = ev.detail;
    paintPrice();
  });

  /* Only charged when a variant exists to charge it against. Without one
     the card is still printed and still reaches the order as properties —
     it is simply free, which is a merchandising gap rather than a reason
     to quote the customer a number the order will not contain. */
  function cardFee() {
    return ded.card && ded.cardVariantId ? (ded.feeCents || 0) : 0;
  }

  /* A card ordered with nothing written on it. Nothing pre-selects a
     message any more — pre-selecting one is how a daughter's dedication
     ended up ticked on a gift for a wife — so an untouched page reaches
     the button with Kartica=Da and an empty Poruka. Sending that prints a
     blank card, and at the packing bench a blank card is indistinguishable
     from one that was ordered and lost. Ask before taking the money. */
  function dedicationIncomplete() {
    return ded.card === true && ded.ready === false;
  }

  /* ---------- the basket ---------------------------------- */
  /* Pieces the customer already parked with "dodaj jos jedan poklon",
     each carrying its own dedication. Read from the JSON the basket
     snippet renders, so the figure on the button and the lines in the
     payload come from one source and cannot drift apart.

     Re-read on every call rather than cached: mc-drawer.js replaces the
     whole basket after a quantity change, and a cached copy would keep
     quoting the total from before it. */
  function basket() {
    var el = document.querySelector('[data-mc-basket-json]');
    if (!el) return { totalCents: 0, lines: [] };
    try {
      var b = JSON.parse(el.textContent);
      return { totalCents: b.totalCents || 0, lines: b.lines || [] };
    } catch (e) {
      /* Unreadable basket: quote and send only the piece on screen. An
         order short one line is recoverable by phone; an order with a
         total nobody can explain is refused at the door. */
      return { totalCents: 0, lines: [] };
    }
  }

  /* The title/price block is a sibling of this form, not a descendant — one
     sticky card can only be one box, so they live outside [data-bh-cod]. */
  var heroPrice   = document.querySelector('[data-bh-hero-price]');
  var heroCompare = document.querySelector('[data-bh-hero-compare]');
  var heroSave    = document.querySelector('[data-bh-hero-save]');

  function paintPrice() {
    /* The hero shows the PRODUCT price — it is the number in the ad, and an
       ad-to-page mismatch loses more orders than it saves. The button shows
       what the courier will actually ask for. */
    /* Delivery is charged once for the whole order, not once per piece —
       that is the promise the split-shipment line in the basket makes. */
    var payable = money(goods() + SHIPPING + cardFee() + basket().totalCents);
    if (totalEl) totalEl.textContent = payable;

    /* the breakdown under the button has to follow the pack picker too, or
       it explains a total that is no longer the one being charged */
    var sum = function (k, text) {
      var n = root.querySelector('[data-bh-sum="' + k + '"]');
      if (n) n.textContent = text;
    };
    /* Goods = the piece on screen PLUS everything already parked in the
       basket. Showing only the former left the rows adding up to less
       than the total, which on cash on delivery is the number somebody
       checks at their own door before handing money over. */
    sum('product', money(goods() + basket().totalCents));
    sum('card', cardFee() ? money(cardFee()) : '');
    sum('total', payable);
    /* Not on a sold-out product. Liquid wrote "Trenutno nema na stanju" onto
       this button and disabled it; quoting a price over that offers a deal
       the shop cannot honour, on the one control the customer cannot press. */
    if (ctaLabel && !SOLD_OUT) ctaLabel.textContent = ctaLabel.dataset.base + ' — ' + payable;
    var stickyPrice = document.querySelector('[data-bh-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = payable;

    if (heroPrice) heroPrice.textContent = money(currentPrice);

    /* With no picker there is nothing to repaint — Liquid already rendered
       the one variant's compare price, and recomputing it from a pack that
       does not exist would wipe a real discount off a single-variant page. */
    if (!packs.length) return;

    /* A pack with no compare price must not keep the previous pack's struck
       figure on screen — that is a false discount. */
    var pack = current();
    var compare = pack ? parseInt(pack.dataset.compare, 10) || 0 : 0;
    var saves = compare > currentPrice;
    if (heroCompare) {
      heroCompare.textContent = saves ? money(compare) : '';
      heroCompare.hidden = !saves;
    }
    if (heroSave) {
      heroSave.textContent = saves
        ? (heroSave.dataset.base || '') + ' ' + money(compare - currentPrice)
        : '';
      heroSave.hidden = !saves;
    }
  }

  function current() {
    for (var i = 0; i < packs.length; i++) {
      if (packs[i].getAttribute('aria-checked') === 'true') return packs[i];
    }
    return null;
  }

  if (ctaLabel) ctaLabel.dataset.base = (ctaLabel.textContent.split('—')[0] || '').trim();

  /* ---------- magnetni ramovi (sections/mc-frame-builder.liquid) ----------
     Isti ugovor kao posveta: sekcija drži izbor, ova forma drži narudžbu.
     data-state na [data-mc-frame] je početno stanje (redoslijed skripti
     onda nije bitan), a mc:frame stiže na svaku promjenu:
       { variantId, unitCents, qty, goodsCents, props }
     Jedna linija: varijanta × broj ramova, pa lager skida tačno toliko
     ramova sa šifre (WH-20, OA-279…). */
  function readFrame(el) {
    try {
      var st = el && el.dataset.state ? JSON.parse(el.dataset.state) : null;
      return st && st.variantId ? st : null;
    } catch (e) { return null; }
  }
  var frame = readFrame(document.querySelector('[data-mc-frame]'));

  function applyFrame() {
    if (!frame) return;
    if (variantEl && frame.variantId) variantEl.value = frame.variantId;
    currentPrice = parseInt(frame.unitCents, 10) || currentPrice;
    if (qtyEl) qtyEl.value = frame.qty;
    var hiddenQty = root.querySelector('[data-bh-form] input[name="quantity"]');
    if (hiddenQty) hiddenQty.value = frame.qty;
    renderMix();
    paintPrice();
  }

  document.addEventListener('mc:frame', function (ev) {
    if (!ev.detail) return;
    frame = ev.detail;
    applyFrame();
  });

  if (qtyEl) {
    var qMinus = root.querySelector('[data-bh-qty-minus]');
    var qPlus  = root.querySelector('[data-bh-qty-plus]');
    if (qMinus) qMinus.addEventListener('click', function () { setQty(qty() - 1); });
    if (qPlus)  qPlus.addEventListener('click',  function () { setQty(qty() + 1); });
    /* input i change: prvi hvata strelice i lijepljenje, drugi izlazak iz
       polja. Bez oba, upisana trojka ostane na ekranu a cijena na jedinici. */
    qtyEl.addEventListener('input',  function () { renderMix(); paintPrice(); });
    qtyEl.addEventListener('change', function () { setQty(qty()); });
  }

  if (mixRows) {
    mixRows.addEventListener('change', function (e) {
      if (e.target.matches('[data-mc-mix-pick]')) paintPrice();
    });
  }

  if (packs.length) {
    Array.prototype.forEach.call(packs, function (p) {
      p.addEventListener('click', function () { selectPack(p); });
      if (p.getAttribute('aria-checked') === 'true') {
        currentPrice = parseInt(p.dataset.price, 10);
        currentPack  = p.dataset.packName || '';
      }
    });
  }
  applyFrame();
  paintPrice();

  /* ---------- submit -------------------------------------- */
  /* Tells the inline guard in the section that the real handler is attached,
     so it can stop holding presses. Set before the listener is added rather
     than after: between the two there is no window for a press to fall
     through, because the guard cancels every native POST either way. */
  form.setAttribute('data-bh-live', 'true');
  /* The guard cancels every native POST. If this shop is configured to use
     Shopify's checkout rather than the worker, that POST is the whole
     mechanism, so hand the guard its exemption. */
  if (MODE !== 'worker' || !ENDPOINT) form.setAttribute('data-bh-native', 'true');

  form.addEventListener('submit', function (ev) {
    /* Before the fields: a card was ordered and nothing was written on it.
       Handled here rather than as a RULES entry because it is not a field
       on this form — it lives in another section — and because it names
       itself in the error rather than naming a label that does not exist. */
    if (dedicationIncomplete()) {
      ev.preventDefault();
      if (formErr) {
        formErr.textContent = root.dataset.errNoMessage ||
          'Narudžba nije poslana. Izaberite poruku za karticu ili napišite svoju.';
        formErr.hidden = false;
      }
      var d = document.querySelector('[data-mc-dedication]');
      if (d && d.scrollIntoView) d.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var firstMsg = document.querySelector('[data-mc-msg]');
      if (firstMsg && firstMsg.focus) firstMsg.focus({ preventScroll: true });
      return;
    }

    var bad = validateAll(true);
    showFormError(bad);

    if (bad.length) {
      ev.preventDefault();
      var el = inputOf(bad[0]);
      /* scrollIntoView is avoided on purpose — it fights the sticky bar */
      var y = el.getBoundingClientRect().top + window.pageYOffset - 90;
      window.scrollTo(0, y < 0 ? 0 : y);
      el.focus();
      return;
    }

    /* Mode 1: let the browser POST to /cart/add?return_to=/checkout */
    if (MODE !== 'worker' || !ENDPOINT) return;

    /* Mode 2: intercept and create the order server-side */
    ev.preventDefault();
    if (sending) return;
    sending = true;
    lockButton(true);

    /* The dedication rides on the LINE, not on the order. An order holding
       a necklace for a mother and one for a daughter carries two different
       texts, and an order-level note cannot say which belongs to which.
       The worker maps these onto per-line customAttributes.

       variantId and quantity stay in the payload alongside lineItems: the
       worker prefers the array when it is present and folds the flat shape
       in when it is not, so sending both is compatible in either
       direction and costs nothing. */
    var lineProps = {};
    if (frame) {
      /* Ramovi nemaju karticu; nose svoja polja (slike, napomena). */
      lineProps = frame.props || {};
    } else if (ded.card) {
      lineProps['Kartica'] = 'Da';
      if (ded.text) lineProps['Poruka'] = ded.text;
      if (ded.sign) lineProps['Potpis'] = ded.sign;
      if (ded.extra) {
        Object.keys(ded.extra).forEach(function (k) {
          if (ded.extra[k]) lineProps[k] = ded.extra[k];
        });
      }
    } else {
      /* Explicit "Ne", not an absent key. A blank dedication on a printed
         order is ambiguous at the packing bench — it reads the same as a
         card that was ordered and failed to arrive. */
      lineProps['Kartica'] = 'Ne';
    }

    /* Prva linija nosi posvetu; dodatni komadi su isti poklon iz iste
       kutije, pa nose istu. Ista varijanta izabrana dvaput je jedna
       linija sa kolicinom dva. */
    var items = orderCounts().map(function (c) {
      return { variantId: c.id, quantity: c.n, properties: lineProps };
    });
    if (!items.length) {
      items = [{
        variantId: variantEl ? variantEl.value : '',
        quantity: qty(),
        properties: lineProps
      }];
    }

    /* The card is billed as its own hidden line, never as a variant of the
       jewellery. That is the rule keeping the catalogue at fifteen pieces
       instead of the 250 that recipient x message produced.

       No variant configured means no charge line — the card still prints
       and still reaches the order through the properties above. */
    if (ded.card && ded.cardVariantId) {
      items.push({ variantId: ded.cardVariantId, quantity: 1 });
    }

    /* Then everything already parked in the basket, each with the
       dedication it was parked with. The worker merges lines only when
       variant AND properties match, so two identical necklaces carrying
       two different texts survive as two lines. */
    basket().lines.forEach(function (l) {
      if (l && l.variantId) items.push(l);
    });

    var payload = {
      lineItems: items,
      variantId: variantEl ? variantEl.value : '',
      quantity: qty(),
      name:    inputOf('name').value.trim(),
      phone:   inputOf('phone').value.trim(),
      address: inputOf('address').value.trim(),
      city:    inputOf('city').value.trim(),
      zip:     inputOf('zip') ? inputOf('zip').value.trim() : '',
      email:   inputOf('email') ? inputOf('email').value.trim() : '',
      note:    'COD — Shopify tema BiH',
      url:     location.href
    };

    var timeout = setTimeout(failSoft, 12000);

    /* One quiet retry, and only when the request never reached the worker.

       A fetch that rejects rather than answering is a dropped connection —
       a phone stepping between masts, a lift, a tunnel — and on this market
       most orders come from a phone. Making the customer read an error and
       press the button again loses some of them to something that would
       have worked a second later.

       Only network failures are retried. Anything the worker actually
       answered — a refusal, a rate limit, a validation error — is a
       decision, and repeating it would just place the same order twice. */
    var attempt = function (retriesLeft) {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).catch(function (err) {
        if (!retriesLeft) throw err;
        return new Promise(function (res) {
          setTimeout(function () { res(attempt(retriesLeft - 1)); }, 1200);
        });
      });
    };

    attempt(1)
      /* The body is read even on a failure. Every refusal used to arrive as
         the same silent throw, so "check your connection" was printed at a
         customer whose connection was fine and who had simply ordered twice
         in an hour — advice that cannot work, given to someone who cannot
         act on it. The worker names its reasons; this reads the name. */
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok) return d;
          var e = new Error('HTTP ' + r.status);
          e.status = r.status;
          e.code = d && d.error;
          e.detail = d && d.detail;
          throw e;
        });
      })
      .then(function (data) {
        clearTimeout(timeout);
        startOffers(data, payload);
      })
      .catch(function (err) {
        clearTimeout(timeout);
        failSoft(err);
      });
  });

  /* Somebody pressed ORDER while this file was still on the wire. The guard
     cancelled the POST and left a flag; honour the press now rather than
     making them find the button again. */
  if (form.getAttribute('data-bh-early') === 'true') {
    form.removeAttribute('data-bh-early');
    if (submitBtn) submitBtn.removeAttribute('data-bh-waiting');
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function lockButton(on) {
    if (!submitBtn) return;
    submitBtn.disabled = on;
    submitBtn.style.opacity = on ? '.65' : '';
    if (ctaLabel) {
      ctaLabel.textContent = on
        ? (root.dataset.sendingLabel || 'ŠALJEMO…')
        : ctaLabel.dataset.base + ' — ' + money(currentPrice);
    }
  }

  /* If the worker is down the customer must NOT lose the order. */
  /* This used to hand the customer to Shopify's checkout when the worker was
     slow or unreachable. It was the wrong rescue: this shop takes payment at
     the door, and Shopify's checkout asks for a card. A customer who filled
     in a COD form and pressed ORDER landed on a card form in English with
     their name and address glued on as line-item properties — no order was
     created, and the ones who did not abandon paid twice over in confusion.
     Better to stay on our own page and say plainly that it did not go
     through, with the phone number already on screen a thumb away. */
  /* Every refusal is reported, because the person it happened to is the
     most valuable name the shop will see all day: they typed their address
     and asked to buy. Until this existed they simply vanished — the page
     apologised and nobody ever knew. Fire and forget, keepalive so it
     survives the tab being closed in frustration, and wrapped so a failure
     to log a failure cannot become a second failure. */
  function reportFailure(err) {
    if (!ENDPOINT) return;
    try {
      var val = function (k) { var i = inputOf(k); return i ? i.value.trim() : ''; };
      fetch(ENDPOINT.replace(/\/+$/, '') + '/fail', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify({
          reason: err && (err.status === 429 || err.code === 'rate') ? 'rate'
                : err && err.status ? 'http-' + err.status
                : err ? 'mreza' : 'timeout',
          /* The worker says exactly what went wrong; only its short code
             was being written down, so three lost orders read "shopify"
             and the reason had to be reproduced by hand afterwards. */
          detail: err ? String(err.detail || err.code || err.message || '').slice(0, 300) : '',
          name: val('name'), phone: val('phone'), address: val('address'),
          city: val('city'), zip: val('zip'), email: val('email'),
          product: PRODUCT + (currentPack ? ' — ' + currentPack : ''),
          total: goods() + SHIPPING,
          url: location.href
        })
      }).catch(function () {});
    } catch (e) { /* never let logging break the page */ }
  }

  function failSoft(err) {
    if (!sending) return;
    sending = false;
    lockButton(false);
    reportFailure(err);
    if (formErr) {
      var code = err && err.code;
      var rate = err && (err.status === 429 || code === 'rate');
      /* Naming the field is the whole point. Three orders were lost in one
         morning to a phone number Shopify would not accept, and every one
         of those customers was told to check their internet — advice that
         could not work, about a problem they could have fixed in seconds. */
      formErr.textContent = code === 'phone'
        ? (root.dataset.errPhoneLabel
            || 'Provjerite broj telefona — izgleda da nedostaje cifra.')
        : rate
          ? (root.dataset.errRateLabel
              || 'Već ste poslali narudžbu maloprije. Sačekajte malo ili nas nazovite.')
          : (root.dataset.errSendLabel
              || 'Narudžba nije poslana. Provjerite internet i pokušajte ponovo, ili nas nazovite.');
      formErr.hidden = false;
    }
    var focusOn = (err && err.code === 'phone') ? inputOf('phone') : (formErr || form);
    if (focusOn && err && err.code === 'phone') {
      fieldOf('phone').setAttribute('data-invalid', 'true');
      focusOn.focus();
    }
    var y = (focusOn || form).getBoundingClientRect().top + window.pageYOffset - 90;
    window.scrollTo(0, y < 0 ? 0 : y);
  }

  /* ---------- one-click upsell queue ----------------------- */
  /* Runs only AFTER the worker has created the order. Every offer appends a
     line to an order that already exists, so abandoning at any point — a
     decline, a dead endpoint, a closed tab — leaves precisely the order the
     customer would have had if this queue did not exist. That property is
     the whole design; nothing below is allowed to break it.

     The worker has to return `orderId` and a short-lived signed `token`
     alongside the order for any of this to run. Until it does, the offers
     stay hidden and the customer goes straight to the confirmation, exactly
     as before — which is what makes it safe to ship this half first. */
  /* document, not root: the cards live in their own section now, so the
     same list can serve the sheet on app-built pages too */
  var offers    = [].slice.call(document.querySelectorAll('[data-bh-pane="offer"]'));
  var offerIdx  = 0;
  var runTotal  = 0;
  var orderRef  = null;
  var offerBusy = false;
  /* what the customer actually said yes to, so the confirmation can name it.
     A recap showing one product and a total covering three is the moment
     somebody starts wondering what they have been charged for. */
  var accepted = [];
  var TIMER_MIN = parseInt(root.dataset.offerTimer, 10) || 0;
  var tick      = null;

  /* While an offer is up it owns the screen: the phone button, the
     guarantees and every section below the form are taken out of flow, so
     the offer is not competing with another call to action and nothing
     that follows it can creep above the fold. Undone on the confirmation. */
  function offerMode(on) {
    document.body.toggleAttribute('data-bh-offer-open', !!on);
  }

  function stopTimer() {
    if (tick) { clearInterval(tick); tick = null; }
  }

  /* One countdown per offer, restarted each time. On zero the offer declines
     itself and the queue moves on — the order was created before any of this
     and is not touched either way. */
  function startTimer(el, onExpiry) {
    stopTimer();
    var out = el.querySelector('[data-bh-offer-timer]');
    if (!out || TIMER_MIN <= 0) { if (out) out.hidden = true; return; }

    var left = TIMER_MIN * 60;
    out.hidden = false;
    var paint = function () {
      var m = Math.floor(left / 60);
      var s = left % 60;
      out.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    };
    paint();
    tick = setInterval(function () {
      left -= 1;
      if (left <= 0) { stopTimer(); out.textContent = '0:00'; return onExpiry(); }
      paint();
    }, 1000);
  }

  /* Past this line the order exists in Shopify. Everything the offer queue
     does afterwards is a bonus, and no bonus is allowed to cost the customer
     the one thing they are owed: being told the order was taken.

     This is not hypothetical. A stray closing tag once left the confirmation
     outside the element this script searches, so `paneDone` was null; the
     form hid itself, the offer machinery threw, and the customer sat looking
     at an empty card wondering whether to order again. Several did.

     So the queue runs inside a net. Anything it throws lands on the
     confirmation, and if even that cannot be drawn the form comes back with
     the order number in the error line — ugly, but it never lies about
     whether the order exists. */
  function startOffers(data, payload) {
    runTotal = data.totalCents != null ? data.totalCents : currentPrice;
    orderRef = (data.orderId && data.token)
      ? { id: data.orderId, token: data.token }
      : null;

    try { localStorage.removeItem(STORE_KEY); } catch (e) {}
    if (sticky) sticky.setAttribute('data-visible', 'false');

    try {
      /* Not just "is it null". The element is looked up when the script
         starts, so anything that replaces the card afterwards — a section
         re-render in the theme editor, an app rewriting the DOM, a bad
         merge of the markup — leaves this variable pointing at a node that
         is no longer on the page. Writing the confirmation into it then
         succeeds silently and shows the customer nothing at all, which is
         the exact failure this net exists to catch. */
      if (!paneDone || !document.contains(paneDone)) throw new Error('nema potvrde');
      paneForm.hidden = true;
      if (!orderRef || !offers.length) return showConfirmation(data, payload);
      offerIdx = 0;
      nextOffer(data, payload);
    } catch (e) {
      lastResort(data);
    }
  }

  /* The confirmation itself is broken. Say the one true thing that is left,
     in the place the customer is already looking. */
  function lastResort(data) {
    var num = (data && (data.orderNumber || data.name)) || '';
    if (paneForm) paneForm.hidden = false;
    if (formErr) {
      formErr.textContent = (root.dataset.confirmedFallback
        || 'Narudžba je primljena. Broj narudžbe: ') + num;
      formErr.hidden = false;
      formErr.setAttribute('data-ok', 'true');
    }
    if (submitBtn) submitBtn.disabled = true;
  }

  function nextOffer(data, payload) {
    try {
      drawOffer(data, payload);
    } catch (e) {
      /* a broken offer must not swallow a good order */
      try { showConfirmation(data, payload); } catch (e2) { lastResort(data); }
    }
  }

  function drawOffer(data, payload) {
    stopTimer();
    offers.forEach(function (o) { o.hidden = true; });
    if (offerIdx >= offers.length) return showConfirmation(data, payload);

    offerMode(true);
    var el = offers[offerIdx];
    el.hidden = false;
    /* The offer has to be readable without scrolling, so put its top at the
       top of the viewport rather than nudging it into view. */
    var y = el.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo(0, y < 0 ? 0 : y);

    var yes = el.querySelector('[data-bh-offer-yes]');
    var no  = el.querySelector('[data-bh-offer-no]');
    var skip = function () { offerIdx++; nextOffer(data, payload); };
    if (no)  no.onclick  = skip;
    if (yes) yes.onclick = function () { acceptOffer(el, data, payload); };
    startTimer(el, skip);
  }

  function acceptOffer(el, data, payload) {
    if (offerBusy) return;
    offerBusy = true;
    var yes = el.querySelector('[data-bh-offer-yes]');
    if (yes) { yes.disabled = true; yes.style.opacity = '.65'; }

    stopTimer();
    var price = parseInt(el.dataset.price, 10) || 0;
    var title = el.querySelector('.bh-offer__h');
    if (title) accepted.push(title.textContent.trim());
    /* Whatever happens next, move on — an upsell must never strand someone
       on a spinner after their order is already placed. */
    var done = function (added) {
      offerBusy = false;
      if (yes) { yes.disabled = false; yes.style.opacity = ''; }
      if (added != null) runTotal = added;
      offerIdx++;
      nextOffer(data, payload);
    };
    /* Same reasoning as the catch below: after nine seconds we do not know
       whether the line landed, and guessing that it did prints a total the
       courier may not be collecting. Move on without it. The confirmation
       call the shop makes on every order is where a late arrival gets
       sorted out. */
    var give = setTimeout(function () {
      if (title) {
        var i = accepted.lastIndexOf(title.textContent.trim());
        if (i > -1) accepted.splice(i, 1);
      }
      done(null);
    }, 9000);

    fetch(ENDPOINT.replace(/\/+$/, '') + '/upsell', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderId:     orderRef.id,
        token:       orderRef.token,
        variantId:   el.dataset.variant,
        discountPct: parseInt(el.dataset.discount, 10) || 0,
        quantity:    1
      })
    })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
      .then(function (res) {
        clearTimeout(give);
        done(res && res.totalCents != null ? res.totalCents : runTotal + price);
      })
      .catch(function () {
        /* The request failed, so the line is very probably not on the order.
           Take the offer back out of the recap and off the total rather than
           printing a figure the courier will not be collecting: this is cash
           on delivery, and a receipt that promises an item the driver is not
           carrying is worse than one that never mentioned it. Shopify is the
           record; the page follows it, not the other way round. */
        clearTimeout(give);
        if (title) {
          var i = accepted.lastIndexOf(title.textContent.trim());
          if (i > -1) accepted.splice(i, 1);
        }
        done(null);
      });
  }


  /* ---------- add more, into the same order ---------------- */
  /* The catalogue comes from Shopify on the shop's own domain, not through
     the worker. The worker holds an Admin API token, and putting the
     product list behind it would guard a public catalogue with a
     credential and spend a request on something Shopify already caches.

     Fetched once, and only after an order exists — rendering these rows
     into every product page would hand the whole catalogue to every
     visitor, and most visitors never order. */
  var moreWrap = root.querySelector('[data-bh-more]');
  var moreGrid = root.querySelector('[data-bh-more-grid]');
  var moreNote = root.querySelector('[data-bh-more-note]');
  var moreBusy = false;

  function moreSay(text) {
    if (!moreNote) return;
    moreNote.textContent = text || '';
    moreNote.hidden = !text;
  }

  function openMore(data, payload) {
    if (!moreWrap || !moreGrid || !orderRef) return;
    var url = root.dataset.moreUrl;
    if (!url) return;

    /* No Accept header. Asking Shopify for application/json on a storefront
       URL makes it answer 404 with an empty body — it reads the header as a
       call to an API that does not exist, rather than a request for this
       template. The template returns JSON either way; the header was mine,
       and it was the whole bug. */
    /* Shopify throttles, and a throttled storefront answers 429 with an HTML
       error page — which parses as nothing and leaves an empty list where
       the catalogue should be. One retry, two seconds later, because the
       thing being lost here is the only place a second item can be added to
       an order that already exists. */
    function grab(tries) {
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).catch(function (err) {
        if (tries <= 0) throw err;
        return new Promise(function (ok) { setTimeout(ok, 2000); }).then(function () {
          return grab(tries - 1);
        });
      });
    }

    grab(1)
      .then(function (d) {
        var list = (d && d.products || []).filter(function (p) {
          /* never offer what they just bought */
          return String(p.variantId) !== String(variantEl && variantEl.value);
        });
        if (!list.length) return;
        list.forEach(function (p) { moreGrid.appendChild(moreCard(p, data, payload)); });
        moreWrap.hidden = false;
      })
      .catch(function () { /* no list is not a failure; the order stands */ });
  }

  function moreCard(p, data, payload) {
    var el = document.createElement('div');
    el.className = 'bh-more__item';
    var img = p.image
      ? '<img class="bh-more__img" src="' + p.image + '" alt="" width="80" height="80" loading="lazy">'
      : '<span class="bh-more__img"></span>';
    el.innerHTML = img
      + '<span class="bh-more__t"></span>'
      + '<span class="bh-more__p">' + money(p.price) + '</span>'
      + '<button type="button" class="bh-more__add"></button>';
    el.querySelector('.bh-more__t').textContent = p.title;
    /* Tap the photo to see the product properly.

       A swipe gallery inside the card itself was the obvious idea and the
       wrong one: the cards are 170px wide on a phone, and a horizontal
       swipe that narrow, nested inside the page's own vertical scroll, is
       something a thumb finds by accident rather than on purpose. Full
       screen has neither problem — it is its own surface, so the swipe has
       nowhere to conflict, and it is the gesture people already use for
       photos everywhere else.

       Nothing is loaded until it is opened. */
    var shots = (p.shots || []).filter(Boolean);
    var thumb = el.querySelector('.bh-more__img');
    if (shots.length && thumb && thumb.tagName === 'IMG') {
      thumb.setAttribute('role', 'button');
      thumb.setAttribute('tabindex', '0');
      thumb.addEventListener('click', function () { openShots(shots, p.title); });
      thumb.addEventListener('keydown', function (ev) {
        if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); openShots(shots, p.title); }
      });
    }

    var btn = el.querySelector('.bh-more__add');
    btn.textContent = root.dataset.moreAdd || 'Dodaj';

    /* One variant: one tap, straight in. Several: ask.

       These used to be left out of the list entirely, on the reasoning that
       a one-tap add cannot ask which size somebody wants — which quietly
       removed the knee brace and everything else sold in sizes, several of
       them the shop's best. Guessing is worse than asking: a brace sent in
       the wrong size comes straight back at the shop's expense, and on cash
       on delivery it is refused at the door and the whole parcel returns.

       So the button opens the sizes in place. Still no navigation, still
       inside the confirmation, one extra tap for the products that need
       one. */
    var choices = (p.variants || []).filter(function (x) { return x && x.id; });
    if (choices.length > 1) {
      var pick = document.createElement('div');
      pick.className = 'bh-more__pick';
      pick.hidden = true;
      choices.forEach(function (c) {
        var chip = document.createElement('button');
        chip.type = 'button';
        chip.className = 'bh-more__chip';
        chip.textContent = c.title;
        chip.addEventListener('click', function () {
          addMore({ variantId: c.id, title: p.title + ' — ' + c.title }, el, btn, data, payload);
        });
        pick.appendChild(chip);
      });
      el.insertBefore(pick, btn);
      btn.addEventListener('click', function () {
        if (el.getAttribute('data-added')) return;
        pick.hidden = !pick.hidden;
        btn.textContent = pick.hidden
          ? (root.dataset.moreAdd || 'Dodaj')
          : (root.dataset.morePick || 'Izaberi veličinu');
      });
      return el;
    }

    btn.addEventListener('click', function () { addMore(p, el, btn, data, payload); });
    return el;
  }


  /* The full-screen photo viewer. One element, reused, built the first time
     it is needed. Swiping is the browser's own scroll with snap points
     rather than a gesture library — it is smoother than anything hand
     written, and it keeps this file the only script the theme ships. */
  var shotBox = null;
  function openShots(list, title) {
    if (!shotBox) {
      shotBox = document.createElement('div');
      shotBox.className = 'bh-shots';
      shotBox.setAttribute('role', 'dialog');
      shotBox.setAttribute('aria-modal', 'true');
      shotBox.innerHTML =
        '<button type="button" class="bh-shots__x" aria-label="Zatvori">&times;</button>'
        + '<div class="bh-shots__strip"></div>'
        + '<p class="bh-shots__t"></p>';
      shotBox.addEventListener('click', function (ev) {
        if (ev.target === shotBox || ev.target.classList.contains('bh-shots__x')) closeShots();
      });
      document.body.appendChild(shotBox);
    }
    var strip = shotBox.querySelector('.bh-shots__strip');
    strip.innerHTML = '';
    list.forEach(function (src) {
      var im = document.createElement('img');
      im.src = src;
      im.alt = '';
      im.loading = 'lazy';
      strip.appendChild(im);
    });
    strip.scrollLeft = 0;
    shotBox.querySelector('.bh-shots__t').textContent = title || '';
    shotBox.setAttribute('data-open', 'true');
    document.body.style.overflow = 'hidden';
    document.addEventListener('keydown', onShotKey);
  }

  function closeShots() {
    if (!shotBox) return;
    shotBox.removeAttribute('data-open');
    document.body.style.overflow = '';
    document.removeEventListener('keydown', onShotKey);
  }

  function onShotKey(ev) { if (ev.key === 'Escape') closeShots(); }

  function addMore(p, el, btn, data, payload) {
    /* One at a time. Two order edits racing each other on the same order is
       how a line goes missing, and the customer would have no way to know
       which of their taps counted. */
    if (moreBusy || btn.disabled) return;
    moreBusy = true;
    btn.disabled = true;
    var was = btn.textContent;
    btn.textContent = root.dataset.sendingLabel || '…';
    moreSay('');

    var give = setTimeout(function () { moreFail(btn, was, null); }, 12000);

    fetch(ENDPOINT.replace(/\/+$/, '') + '/upsell', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        orderId: orderRef.id, token: orderRef.token,
        variantId: p.variantId, discountPct: 0, quantity: 1
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (r.ok) return d;
          var e = new Error('HTTP ' + r.status); e.code = d && d.error; throw e;
        });
      })
      .then(function (res) {
        clearTimeout(give);
        moreBusy = false;
        /* the worker returns the order's NEW total, so the line the customer
           reads is the figure the courier will actually ask for */
        if (res && res.totalCents != null) {
          runTotal = res.totalCents;
          set('total', money(runTotal));
        }
        var cell = paneDone.querySelector('[data-bh-recap="product"]');
        if (cell) {
          var li = document.createElement('span');
          li.className = 'bh-recap__add';
          li.textContent = '+ ' + p.title;
          cell.appendChild(li);
        }
        el.setAttribute('data-added', 'true');
        var pickEl = el.querySelector('.bh-more__pick');
        if (pickEl) pickEl.hidden = true;
        btn.disabled = true;
        btn.textContent = root.dataset.moreAdded || '✓';
      })
      .catch(function (err) {
        clearTimeout(give);
        moreFail(btn, was, err);
      });
  }

  /* Nothing was added, so nothing is claimed. The recap and the total are
     left exactly as they were — on cash on delivery a receipt promising an
     item the driver is not carrying starts an argument at the door. */
  function moreFail(btn, was, err) {
    moreBusy = false;
    btn.disabled = false;
    btn.textContent = was;
    var gone = err && (err.code === 'expired' || err.code === 'token');
    moreSay(gone
      ? (root.dataset.moreExpired || 'Vrijeme za dodavanje je isteklo. Nazovite nas i dodaćemo.')
      : (root.dataset.moreFailed || 'Nije dodano. Pokušajte ponovo ili nas nazovite.'));
  }

  function showConfirmation(data, payload) {
    try { localStorage.removeItem(STORE_KEY); } catch (e) {}

    stopTimer();
    offerMode(false);
    offers.forEach(function (o) { o.hidden = true; });

    /* The order is placed, so the page stops being a shop window. Price,
       stock, "order by phone", the guarantees and everything after the form
       all describe a decision that has already been made — leaving them up
       reads as though nothing happened, and the phone button invites a
       second order for the same thing. One attribute, so the rule lives in
       CSS next to the layout it undoes. */
    document.body.setAttribute('data-bh-ordered', '');

    set('order',   data.orderNumber || data.name || '#—');
    var bought = currentPack ? PRODUCT + ' — ' + currentPack : PRODUCT;
    var productCell = paneDone.querySelector('[data-bh-recap="product"]');
    if (productCell) {
      productCell.textContent = bought;
      /* each accepted offer on its own line, so the recap adds up to the
         figure printed under it */
      accepted.forEach(function (name) {
        var li = document.createElement('span');
        li.className = 'bh-recap__add';
        li.textContent = '+ ' + name;
        productCell.appendChild(li);
      });
    }
    set('address', payload.address + ', ' + payload.city);

    /* The gift configurator (assets/mc-gift.js) shows the card the customer
       just ordered and lets them fix it, or the delivery, for the thirty
       minutes the order token lives. It needs the order, the token and what
       was typed; nothing here waits for it. */
    try {
      document.dispatchEvent(new CustomEvent('bh:ordered', {
        detail: { data: data || {}, payload: payload || {}, endpoint: ENDPOINT }
      }));
    } catch (e) {}
    /* runTotal, not the figure the order came back with: after an accepted
       offer the courier collects more than the first total, and this line is
       what the customer reads as the amount to have ready. */
    set('total',   money(runTotal || (data.totalCents != null ? data.totalCents : currentPrice)));

    /* The same basket, from the same number, to the same address, inside
       ten minutes. Shopify has one order and only one, and the customer is
       looking at it — but without a word they would reasonably read this
       screen as a second order and expect two parcels. */
    var dupe = paneDone.querySelector('[data-bh-dupe]');
    if (dupe) {
      if (data && data.deduped) {
        var mins = data.agoMin;
        var dtxt = dupe.querySelector('[data-bh-dupe-text]');
        if (dtxt) {
          /* Two facts before the question: what already exists, and that a
             second order does not. Somebody who tapped twice by accident
             needs both of those and nothing more. */
          dtxt.textContent = (mins
            ? (root.dataset.dupeLabel || 'Već ste naručili ovaj proizvod prije {min} min. Druga narudžba nije napravljena.').replace('{min}', mins)
            : (root.dataset.dupeNowLabel || 'Ovaj proizvod ste upravo naručili. Druga narudžba nije napravljena.'));
        }
        /* Somebody sending the same basket twice is usually somebody who
           thinks the first attempt failed — but not always. Some of them
           want two. Refusing both readings leaves the second sort with
           nothing to do but order again from scratch and pay a second
           delivery.

           So it is asked, not assumed, and the question names the number
           that would end up on the order. Nothing happens without the tap;
           down the same order-edit path the list below uses, so it stays
           one parcel and one delivery fee, and the recap and total move to
           the figure the driver will actually collect. */
        var dask = dupe.querySelector('[data-bh-dupe-ask]');
        var dbtn = dupe.querySelector('[data-bh-dupe-add]');
        if (dbtn && payload.variantId) {
          if (dask) dask.hidden = false;
          dbtn.hidden = false;
          dbtn.addEventListener('click', function () {
            addMore({ variantId: payload.variantId, title: PRODUCT },
                    dupe, dbtn, data, payload);
          });
        } else if (dbtn) {
          dbtn.hidden = true;
          if (dask) dask.hidden = true;
        }
        dupe.hidden = false;
      } else {
        dupe.hidden = true;
      }
    }

    var subs = paneDone.querySelectorAll('[data-bh-phone]');
    Array.prototype.forEach.call(subs, function (n) { n.textContent = payload.phone; });

    paneForm.hidden = true;
    paneDone.hidden = false;

    /* The order exists and stays open for half an hour, so this is the one
       moment where "anything else?" costs the customer nothing: same
       parcel, same delivery fee, and the deciding is already done. */
    openMore(data, payload);

    var stickyBar = document.querySelector('[data-bh-sticky]');
    if (stickyBar) stickyBar.setAttribute('data-visible', 'false');

    var y = paneDone.getBoundingClientRect().top + window.pageYOffset - 70;
    window.scrollTo(0, y < 0 ? 0 : y);

    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'purchase',
        transaction_id: data.orderNumber,
        /* the total after any accepted offer, not the one the form started with */
        value: (runTotal || currentPrice) / 100,
        currency: root.dataset.currency || 'BAM'
      });
    }
  }

  function set(key, value) {
    var n = paneDone.querySelector('[data-bh-recap="' + key + '"]');
    if (n) n.textContent = value;
  }

  /* ---------- previewing an offer -------------------------
     An offer is normally unreachable without placing a real order, which
     is a poor way to check whether the wording fits. Two ways in, and
     neither creates or touches anything:

       ?bh_offer=1        the first offer, on the real page, on a phone
       theme editor       select an offer block and it appears

     Buttons only cycle here — accept posts nothing. */
  function previewOffer(i) {
    if (!offers.length) return;
    var el = offers[Math.min(Math.max(i, 0), offers.length - 1)];
    stopTimer();
    offerMode(true);
    paneForm.hidden = true;
    paneDone.hidden = true;
    offers.forEach(function (o) { o.hidden = true; });
    el.hidden = false;

    var stop = function () {
      stopTimer();
      offerMode(false);
      el.hidden = true;
      paneForm.hidden = false;
    };
    var no = el.querySelector('[data-bh-offer-no]');
    var yes = el.querySelector('[data-bh-offer-yes]');
    if (no) no.onclick = stop;
    if (yes) yes.onclick = stop;
    startTimer(el, stop);

    var y = el.getBoundingClientRect().top + window.pageYOffset - 8;
    window.scrollTo(0, y < 0 ? 0 : y);
  }

  var wanted = new URLSearchParams(location.search).get('bh_offer');
  if (wanted) previewOffer(parseInt(wanted, 10) - 1);

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:block:select', function (e) {
      var i = offers.indexOf(e.target);
      if (i >= 0) previewOffer(i);
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      if (offers.indexOf(e.target) < 0) return;
      stopTimer();
      offerMode(false);
      e.target.hidden = true;
      paneForm.hidden = false;
    });
  }

  /* ---------- sticky bar ---------------------------------- */
  var sticky = document.querySelector('[data-bh-sticky]');
  if (sticky) {
    var ticking = false;
    var paint = function () {
      var box = form.getBoundingClientRect();
      /* Hide the bar while the form itself is on screen —
         two identical CTAs at once is the classic COD mistake. */
      var formVisible = box.top < window.innerHeight && box.bottom > 0;
      var pastHero = window.pageYOffset > 320;
      var done = paneDone && !paneDone.hidden;
      /* An offer owns the screen while it is up: the form is hidden, so
         formVisible reads false and the bar would otherwise reappear over
         an offer whose whole point is to fit above the fold. */
      var offering = offers.some(function (o) { return !o.hidden; });
      sticky.setAttribute('data-visible', (pastHero && !formVisible && !done && !offering) ? 'true' : 'false');
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(paint);
    }, { passive: true });
    paint();

    /* Publish the bar's real height so the page can reserve exactly it.

       bh.css used to hard-code 140px of padding under <main> as the
       runway for this fixed bar. The bar measured 132px, then 88px once
       its button stopped wrapping — so every product carried ~50px of
       empty cream above the footer that belonged to nothing, and it was
       reported as "prazan blok u dnu".

       Measured, not guessed: the delivery line wraps on some products
       and not on others, so the bar is not one height. Read after layout
       and on resize; orientationchange goes through resize too. */
    var publishHeight = function () {
      document.documentElement.style.setProperty('--bh-sticky-h', sticky.offsetHeight + 'px');
    };
    publishHeight();
    window.addEventListener('resize', publishHeight, { passive: true });
    /* Web fonts land after first paint and change the label's line count,
       so the first measurement can be a line short. */
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(publishHeight);

    /* If the tab is backgrounded mid-scroll the pending animation frame
       never runs, `ticking` stays true and the bar freezes. Repaint and
       clear the latch whenever the page becomes visible again. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) return;
      ticking = false;
      paint();
    });
    window.addEventListener('pageshow', function () {
      ticking = false;
      paint();
    });

    /* The sticky button NEVER submits. It scrolls to the form
       and focuses the first field. */
    var jump = sticky.querySelector('[data-bh-jump]');
    if (jump) {
      jump.addEventListener('click', function () {
        var y = form.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({ top: y < 0 ? 0 : y, behavior: 'smooth' });
        setTimeout(function () { var i = inputOf('name'); if (i) i.focus(); }, 380);
      });
    }
  }
})();
